define('Winering.ItemRelations.Related.View', [
    'ItemRelations.Related.View',
    'ItemRelations.RelatedItem.View',
    'item_relations_cell.tpl',
    'item_relations_row.tpl',
    'item_relations_related.tpl',
    'SC.Configuration',
    'Backbone',
    'Backbone.CollectionView',
    'ItemRelations.Related.Collection',
    'Winering.Collection',
    'Profile.Model',
    'Utils',
    'jQuery',
    'underscore'
], function WineringItemRelationsRelatedView(
    ItemRelationsRelatedView,
    ItemRelationsRelatedItemView,
    itemRelationsCellTpl,
    itemRelationsRowTpl,
    itemRelationsRelatedTpl,
    Configuration,
    Backbone,
    BackboneCollectionView,
    ItemRelationsRelatedCollection,
    WineringCollection,
    ProfileModel,
    Utils,
    jQuery,
    _
) {
    'use strict';

    _.extend(ItemRelationsRelatedView.prototype, {
        initialize: _.wrap(ItemRelationsRelatedView.prototype.initialize, function initialize(fn, options) {
            var pdp = this.options && this.options.application && this.options.application.getComponent('PDP');
            var itemInfo = pdp && pdp.getItemInfo();
            var self = this;
            var profile = ProfileModel.getInstance();
            var store = profile.get('store') || {};
            var collectionListData;
            var layoutComponent = options.application.getComponent('Layout');
            var wineringClasses = Configuration.get('wineRing.classes');
            var classesSeparated;
            if (wineringClasses && itemInfo && itemInfo.item) {
                classesSeparated = wineringClasses.split(',');
                this.isWineringClass = classesSeparated && classesSeparated.indexOf(itemInfo.item.class) >= 0;
            }
            if (this.isWineringClass) {
                layoutComponent.on('afterShowContent', function afterCompositeViewRender() {
                    if (options.itemsIds && store) {
                        collectionListData = _.findWhere(Configuration.get('wineRing.collectionIdByStore') || [], { storeId: String(store.get('internalid')) });
                        if (collectionListData) {
                            self.loadWineryRelatedItems(collectionListData, itemInfo);
                        }
                    }
                });
                this.view_tracked = false;
            } else {
                fn.apply(this, _.toArray(arguments).slice(1));
            }
        }),
        getContext: _.wrap(ItemRelationsRelatedView.prototype.getContext, function getContext(fn) {
            var originalContext = fn.apply(this, _.toArray(arguments).slice(1));
            originalContext.showCells = originalContext.showCells && this.isWineringClass;
            originalContext.imageUrl = Configuration.get('wineRing.wineRingLogoUrl');
            originalContext.wineCat = this.isWineringClass;
            return originalContext;
        }),
        loadWineryRelatedItems: function loadWineryRelatedItems(collectionListData, itemInfo) {
            var wineRingCollection = new WineringCollection();
            var collection;
            var carousel;
            var imgMinHeight;
            var options = this.options;
            var self = this;
            var carouselOptions = _.extend(Configuration.get('bxSliderDefaults', {}), {
                wrapperClass: 'winery-related-items',
                adaptiveHeight: true
            });

            wineRingCollection.fetch({
                data: {
                    merchant_vintage_id: options.itemsIds,
                    collectionId: collectionListData.collectionId,
                    limit: collectionListData.limit,
                    secondaryCollectionId: collectionListData.secondaryCollectionId,
                    secondaryLimit: collectionListData.secondaryLimit
                }
            }).done(function onDone(data) {
                collection = new ItemRelationsRelatedCollection(data);
                if (collection && collection.models) {
                    _.each(collection.models, function eachCollection(item) {
                        var urlcomponent = item.get('urlcomponent');
                        var dataParams = {
                            'utm_campaign': Configuration.get('wineRing.utmCampaing'),
                            'utm_source': Configuration.get('wineRing.utmSource'),
                            'utm_medium': Configuration.get('wineRing.utmMedium'),
                            'utm_content': itemInfo && itemInfo.item && encodeURIComponent(itemInfo.item.displayname)
                        };
                        item.set('_url', urlcomponent + '?' + jQuery.param(dataParams));
                    });
                }

                BackboneCollectionView.prototype.initialize.call(self, {
                    collection: collection,
                    viewsPerRow: Infinity,
                    cellTemplate: itemRelationsCellTpl,
                    rowTemplate: itemRelationsRowTpl,
                    childView: ItemRelationsRelatedItemView,
                    template: itemRelationsRelatedTpl
                });
                self.render();
                carousel = self.$el.find('[data-type="carousel-items"]');
                if (Utils.isPhoneDevice() === false && self.options.application.getConfig('siteSettings.imagesizes')) {
                    imgMinHeight = (_.where(
                            self.options.application.getConfig('siteSettings.imagesizes'),
                        {
                            name: self.options.application.getConfig('imageSizeMapping.thumbnail')
                        }
                        )[0]).maxheight;

                    carousel.find('.item-relations-related-item-thumbnail').css('minHeight', imgMinHeight);
                }
                Utils.initBxSlider(carousel, carouselOptions);
            });
        }
    });
});
